// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1AWtW","modalFooterButton":"ModalNotes_modalFooterButton__VoDwk"};